import React from "react";
import { ArrowRight } from "lucide-react";

const stats = [
  { value: "60–80%", label: "Moins cher qu'un abonnement" },
  { value: "48h",    label: "Installé chez vous"          },
  { value: "100%",   label: "Données restent chez vous"   },
  { value: "Loi 25", label: "Conformité incluse"          },
];

export default function Hero() {
  return (
    <section
      id="accueil"
      style={{
        minHeight: "100vh",
        background: "linear-gradient(160deg, #f5f5f7 0%, #ffffff 55%)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        paddingTop: "60px",   /* hauteur navbar */
        overflow: "hidden",
      }}
    >
      <div className="section-wrap" style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center" }}>

        {/* ── Two-column layout ── */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "40px",
          alignItems: "center",
          padding: "32px 0 24px",
        }} className="hero-grid">

          {/* ── Left : text ── */}
          <div>
            {/* Badge */}
            <span className="badge-blue" style={{ marginBottom: "20px", display: "inline-flex" }}>
              <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#0071e3", animation: "pulse 2s infinite" }} />
              Pour les PME québécoises · Conforme Loi 25
            </span>

            {/* Headline */}
            <h1 style={{
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontSize: "clamp(2.2rem, 4vw, 3.6rem)",
              fontWeight: 800,
              lineHeight: 1.06,
              letterSpacing: "-0.03em",
              color: "#1d1d1f",
              marginBottom: "18px",
            }}>
              L'IA Locale.<br />
              <span style={{
                background: "linear-gradient(135deg, #0071e3 0%, #34aadc 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}>
                Performante. Privée.
              </span>
            </h1>

            {/* Description */}
            <p style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: "1.0625rem",
              lineHeight: 1.65,
              color: "#6e6e73",
              maxWidth: "420px",
              marginBottom: "28px",
            }}>
              On installe l'IA directement dans votre bureau.{" "}
              <strong style={{ color: "#1d1d1f", fontWeight: 600 }}>
                Vos données ne quittent jamais vos locaux.
              </strong>
            </p>

            {/* CTAs */}
            <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
              <a href="#contact" className="btn-primary">
                Nous contacter <ArrowRight size={15} />
              </a>
            </div>
          </div>

          {/* ── Right : BOX IA image ── */}
          <div style={{ position: "relative", display: "flex", justifyContent: "center", alignItems: "center" }}>
            {/* Glow */}
            <div style={{
              position: "absolute",
              width: "80%", height: "60%",
              background: "radial-gradient(ellipse, rgba(0,113,227,0.15) 0%, transparent 70%)",
              filter: "blur(40px)",
              bottom: 0,
              left: "50%",
              transform: "translateX(-50%)",
              pointerEvents: "none",
            }} />
            <img
              src="/images/box-ia.png"
              alt="BOX IA — Serveur local aInnovation"
              style={{
                width: "100%",
                maxWidth: "520px",
                height: "auto",
                position: "relative",
                zIndex: 1,
                filter: "drop-shadow(0 32px 64px rgba(0,0,0,0.16))",
              }}
            />
          </div>
        </div>

        {/* ── Stats bar ── */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          borderTop: "1px solid rgba(0,0,0,0.07)",
          paddingTop: "28px",
          paddingBottom: "32px",
          gap: "0",
        }} className="stats-grid">
          {stats.map((s, i) => (
            <div key={i} style={{
              textAlign: "center",
              padding: "0 16px",
              borderRight: i < stats.length - 1 ? "1px solid rgba(0,0,0,0.07)" : "none",
            }}>
              <p style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontSize: "clamp(1.4rem, 2.5vw, 2rem)",
                fontWeight: 800,
                letterSpacing: "-0.03em",
                color: "#0071e3",
                lineHeight: 1,
              }}>{s.value}</p>
              <p style={{ fontSize: "0.8rem", color: "#6e6e73", marginTop: "5px", fontWeight: 500 }}>{s.label}</p>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:.4} }
        @media (max-width: 768px) {
          .hero-grid { grid-template-columns: 1fr !important; gap: 24px !important; padding: 24px 0 16px !important; }
          .hero-grid > div:nth-child(2) { order: -1; }
          .stats-grid { grid-template-columns: repeat(2, 1fr) !important; gap: 12px !important; }
        }
      `}</style>
    </section>
  );
}
